import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { baseUrl, stage, axiosDefaultHeader } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import type { ResultRhqUrlInfo } from '../interfaces/RhqInfo'
import { useAuth } from './useAuth'

interface CD06RhqUrlInfoGetProps {
  execRhqUrlInfoGet: () => Promise<ResultRhqUrlInfo>
  loading: loadStatus
}

// CD06 RHQ URL情報取得API呼出
export const useCD06RhqUrlInfoGet = (): CD06RhqUrlInfoGetProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const auth = useAuth()

  const execRhqUrlInfoGet = async () => {
    try {
      setLoading(loadStatus.LOADING)
      const jwt = await auth.getJwt()
      if (jwt === '') {
        setLoading(loadStatus.LOADED)
        //return { success: false, message: errorMsg.SESSION_ERROR }
      }

      const header = Object.assign(axiosDefaultHeader, {
        Authorization: 'Bearer ' + jwt,
      })

      const endpoint = `${baseUrl}${stage}/rhqinfo`
      const response = await axios.get(endpoint, {
        headers: header,
        validateStatus: () => true,
      })

      if (response.status === apiStatus.SUCCESS) {
        return { success: true, info: response.data }
      }
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } finally {
      setLoading(loadStatus.LOADED)
    }
  }

  return { execRhqUrlInfoGet, loading }
}
